import React from 'react';
import SelectInput, { ValueType } from 'react-select';
import CreatableSelect from 'react-select/creatable';
import _ from 'lodash';
import { SelectItem } from 'src/models/common/SelectItem';
import { FieldError } from 'react-hook-form';
import Tooltip from 'react-tooltip-portal';

interface ISelectInputBaseProps {
    label?: string;
    placeholder?: string;
    // TODO: Need to make generic I think
    options?: { id: string | number; name: string }[];
    selectedOption?: { id: string | number; name: string };
    // TODO: May need to expose as a function as well to provide addtn'l functionality
    idField?: string;
    nameField?: string;
    // tslint:disable-next-line
    onChange?: (id: string | number) => void;
    value?: string | number;
    style?: React.CSSProperties;
    error?: FieldError | string;
    isCreatable?: boolean;
    required?: boolean;
    name?: string;
    stateValue?: string | number;
}

const SelectInputBase: React.FC<ISelectInputBaseProps> = React.forwardRef((props, ref) => {
    const creatableRef = React.useRef(null);
    const [hasFocus, setHasFocus] = React.useState(false);
    const [mounted, setMounted] = React.useState(false);
    const [valueChange, setValueChange] = React.useState(undefined);

    React.useEffect(() => {
        setMounted(true);
        return () => setMounted(false);
    });

    React.useEffect(() => {
        if (!!props.stateValue) {
            setValueChange(props.stateValue);
        }
    }, [props.stateValue]);

    const wrapperRef = React.useRef(undefined);

    const handleKeyDown = (evt: React.KeyboardEvent<HTMLElement>) => {
        type reactTarget = {
            target: {
                selectionStart: number;
                selectionEnd: number;
                value: string;
                setSelectionRange: (j: number, k: number) => void;
            };
        };

        type modEvent = React.KeyboardEvent<HTMLInputElement> & reactTarget;

        switch (evt.key) {
            case 'Home':
                evt.preventDefault();
                if (evt.shiftKey) {
                    (evt as modEvent).target.selectionStart = 0;
                } else {
                    (evt as modEvent).target.setSelectionRange(0, 0);
                }
                break;
            case 'End':
                evt.preventDefault();
                const len = (evt as modEvent).target.value.length;
                if (evt.shiftKey) {
                    (evt as modEvent).target.selectionEnd = len;
                } else {
                    (evt as modEvent).target.setSelectionRange(len, len);
                }
                break;
            default:
                return;
                break;
        }
    };

    const handleInputChange = (option: ValueType<{ id: string | number; name: string }, boolean>) => {
        // let val = props.idField ? option[props.idField] : (option as { id: number | string, name: string }).id;
        // if (((option as unknown) as { __isNew__: boolean }).__isNew__) {
        //     val = val.replace('Create ', '');
        //     creatableRef.current.setValue(val);
        // }

        if (props.onChange) {
            if (!option) {
                props.onChange(undefined);
            } else {
                const val = props.idField ? option[props.idField] : (option as { id: number | string; name: string }).id;
                props.onChange(val);
            }
        }
    };

    const selectProps = {
        classNamePrefix: 'dlc-form-select',
        placeholder: props.placeholder,
        onKeyDown: handleKeyDown,
        options: props.options,
        isClearable: true,
        onChange: handleInputChange,
        getOptionValue: props.idField ? (option: SelectItem) => option[props.idField] : (option: SelectItem) => option.id,
        getOptionLabel: props.nameField ? (option: SelectItem) => option[props.nameField] : (option: SelectItem) => option.name,
        value: _.find(props.options, [props.idField || 'id', props.value]),
    };

    let labelClass = 'label';
    labelClass += props.required ? ' is-required' : '';
    // labelClass += props.helperTip ? ' has-helper-tip' : '';

    let inputClass = 'dlc-form-select-wrapper2';
    if (props.error) {
        inputClass += ' has-error';
    }

    const errorPanel = () => {
        if (props.error && typeof props.error === 'string') {
            return <div>{props.error}</div>;
        } else {
            return <div>{(props.error as FieldError)?.message}</div>;
        }
    };

    if (!mounted) {
        return <></>;
    }
    return (
        <div className={inputClass} style={props.style} ref={wrapperRef}>
            {props.label && <label className={labelClass}>{props.label}</label>}

            {/* <select
                onFocus={() => setHasFocus(true)}
                onBlur={() => setHasFocus(false)}
                className={`${selectProps.classNamePrefix} ${inputClass}`}
                name={props?.name}
                defaultValue="default"
                value={!!valueChange && `${valueChange}`}
                onChange={props.onChange}
            >
                <option value="default">Select...</option>
                {props?.options.map((option) => (
                    <option key={`${props?.name}-${option.id}`} value={option.id}>
                        {option.name}
                    </option>
                ))}
            </select> */}

            {!props.isCreatable && (
                <SelectInput
                    name={props?.name}
                    onFocus={() => setHasFocus(true)}
                    onBlur={() => setHasFocus(false)}
                    {...selectProps}
                    value={!!valueChange && props.options.find((option) => option.id === valueChange)}
                />
            )}
            {props.isCreatable && (
                <CreatableSelect
                    ref={creatableRef}
                    {...selectProps}
                    getNewOptionData={(inputValue, optionLabel) => ({
                        id: optionLabel as string,
                        name: `${inputValue}`,
                        __isNew__: true,
                    })}
                    // TODO: return to this, want to put Create/Add in front
                    // formatCreateLabel={val => `Create ${val}`}
                />
            )}

            <Tooltip
                active={props.error && hasFocus}
                parent={wrapperRef.current}
                position="top left"
                className="form-validation-tooltip top"
                timeout={0}
                hoverEvents={false}
                tipStyle={{ pointerEvents: 'none' }}
            >
                {errorPanel()}
            </Tooltip>

            {/* // <SelectInput
            //     classNamePrefix="dlc-form-select"
            //     placeholder={props.placeholder}
            //     onKeyDown={handleKeyDown}
            //     options={props.options}
            //     isClearable={true}
            //     onChange={handleInputChange}
            //     // tslint:disable-next-line
            //     getOptionValue={props.idField ? option => option[props.idField] : option => option['id']}
            //     // tslint:disable-next-line
            //     getOptionLabel={props.nameField ? option => option[props.nameField] : option => option['name']}
            //     value={_.find(props.options, [props.idField || 'id', props.value])}
            // /> */}
        </div>
    );
});

SelectInputBase.defaultProps = {
    isCreatable: false,
    required: false,
};

export default SelectInputBase;



// WEBPACK FOOTER //
// ./src/components/controls/forms/base/SelectInputBase.tsx